import React, { useState, useEffect, useRef } from "react";
import {
  Accordion,
  Alert,
  Button,
  Col,
  Form,
  Row,
} from "react-bootstrap";
import axios from "axios";
import {Prompt, Redirect, useHistory} from "react-router-dom";
import { useSubheader } from "@metronic/layout";
import { HospitalData } from "@components/panels/hospital-data/hospital-data";
import { InssuredData } from "@components/panels/insured-data/inssured-data";
import { Documentation } from "@components/panels/documentation/documentation";
import { Binnacle } from "@components/panels/binnacle/binnacle";
import { MedicAssignationTraking } from "@components/panels/medic-assignation-tracking/medic-assignation-tracking";
import { MedicalFees } from "@components/panels/medical-fee/medical-fees";
import { UpdateCaseType } from "@components/panels/update-case-type/update-case-type";
import { SufferingData } from "@components/panels/suffering-data/suffering-data";
import AuthLetters from "@components/panels/auth-letter/auth-letters";
import {
  getBySlug,
  update,
} from "@services/hospitalization";
import { getLasMcMovementtByCase } from "@services/mc-movements";
import { isEmpty } from "@utils/check-object-empty";
import moment from "moment";
import { REGISTRATION_CASE_TYPE } from '@constants/case-types';
import CaseHeader from "@components/panels/case-header/case-header";
import CaseContext from "@contexts/case-context";
import BlockCaseContext from "@contexts/block-case-context";
import { useCommentValidation } from "@contexts/comment-validation-context";
import WithCommentValidation from "@components/shared/with-comment-validation";
import { useAutomaticCommentSave } from "@hooks/use-automatic-comment-save";
import {isCaseInCorrectModule} from "@utils/check-module-status";
import {CASE_STATUS} from "@constants/case-statuses";
import { getMexicoTimestamp } from "@utils/date-utils";

const ControlDeskDetails = (props) => {
  const subheader = useSubheader();
  const { validateCommentRequired } = useCommentValidation();

  const { slug } = props.match.params;

  const [caseRecord, setCaseRecord] = useState({});
  const [mcMovement, setMcMovement] = useState({});
  const [hasValidationSchema, setHasValidationSchema] = useState(true);
  const [shouldBlockCase, setShouldBlockCase] = useState(true);
  const [shouldIgnoreLeaveMessage, setShouldIgnoreLeaveMessage] = useState(false);

  const { saveCommentAutomatically } = useAutomaticCommentSave({ caseData: caseRecord });
  const { saveCommentAutomaticallyUnam } = useAutomaticCommentSave({
    caseData: caseRecord,
    eventStage: null,
    comment: "FAVOR DE FACTURAR A UNAM, DE NO HACERLO NO SE PODRÁ PAGAR",
    isPageable: false,
    hideReason: true,
  });

  let history = useHistory();
  const inputReasonTracing = useRef();
  const inputReasonMedicInformation = useRef();

  let submitFormMedicAssignation = null;
  let submitFormMedicAssignationErrors = null;

  const bindSubmitFormMedicAssignation = (submitForm) =>
    (submitFormMedicAssignation = submitForm);

  const bindSubmitFormMedicAssignationErrors = (errors) =>
    (submitFormMedicAssignationErrors = errors);

  useEffect(() => {
    getBySlug(slug).then((response) => {
      setCaseRecord(response.data);
      updateCaseWorking(response.data.id, 1);
      getLasMcMovementtByCase(response.data.id).then((currentMcMovemet) =>
        setMcMovement(currentMcMovemet.data)
      );
    });

    subheader.setTitle("Mesa de Control");
  }, [slug]);

  window.onbeforeunload = function() {
    if (!shouldBlockCase) {
      updateCaseWorking(caseRecord.id, 0);
      return;
    }

    updateCaseLocked();
  }

  const updateCaseLocked = () => {
    if (!validateCommentRequired() || shouldBlockCase)
      update({ caseLocked: 1 }, caseRecord.id).then((response) => console.log("Caso bloqueado..."));
  }

  const updateCaseWorking = (caseId, caseWorkingValue) => {
    update({ caseWorking: caseWorkingValue }, caseId).then((response) => console.log("El caso se esta trabajando..."));
  }

  const getHospitalDateHire = (timestamp) => {
    if (REGISTRATION_CASE_TYPE.includes(caseRecord.caseType) && !caseRecord.hospitalDateHire) {
      return timestamp;
    }
    return null;
  }

  const onClickSendDictum = async () => {
    await submitFormMedicAssignation();
    if (isEmpty(submitFormMedicAssignationErrors)) {
      if (!validateCommentRequired()) {
        return;
      }
      
      await saveCommentAutomatically();
      await saveCommentAutomaticallyUnam();
      let timestamp = getMexicoTimestamp();

      update({
        caseStatusId: 5,
        feadictamen: timestamp,
        hospitalDateHire: getHospitalDateHire(timestamp),
        caseWorking: 0,
        caseLocked: 0,
      },caseRecord.id)
      .then((response) => {
        setShouldIgnoreLeaveMessage(true);
        history.push("/mesa_control");
      });
    }
  }

  const onClickSendTracking = async () => {
    setHasValidationSchema(false);
    await submitFormMedicAssignation();
    if (isEmpty(submitFormMedicAssignationErrors)) {
      let reason_sendToSeguimiento = document.getElementById(
        "reason_sendToSeguimiento"
      ).value;
      if (reason_sendToSeguimiento === "") {
        alert("Selecciona una razon para enviar a seguimiento");
        return;
      }

      if (!validateCommentRequired()) {
        return;
      }
      await saveCommentAutomatically();
      await saveCommentAutomaticallyUnam();
      let timestamp = getMexicoTimestamp();

      if (caseRecord.axaCategories === "" || !caseRecord.axaCategories) {
        update(
          {
            caseStatusId: 3,
            tracingReason: reason_sendToSeguimiento,
            feaseguimiento: timestamp,
            caseType: "Seguimiento",
            caseWorking: 0,
            caseLocked: 0,
          },
          caseRecord.id
        ).then((response) => {
          setShouldIgnoreLeaveMessage(true);
          history.push("/mesa_control");
        });
      } else {
        update(
          {
            caseStatusId: 3,
            tracingReason: reason_sendToSeguimiento,
            feaseguimiento: timestamp,
            caseWorking: 0,
            caseLocked: 0,
          },
          caseRecord.id
        ).then((response) => {
          setShouldIgnoreLeaveMessage(true);
          history.push("/mesa_control");
        });
      }
    }
  }

  const onClickSendMedicInformation = async () => {
    await submitFormMedicAssignation();
    if (isEmpty(submitFormMedicAssignationErrors)) {
      let reason_sendToMedicInformation = document.getElementById(
        "reason_sendToMedicInformation"
      ).value;
      if (reason_sendToMedicInformation === "") {
        alert("Debe seleccionar una razon");
        return;
      }

      if (!validateCommentRequired()) {
        return;
      }
      await saveCommentAutomatically();
      await saveCommentAutomaticallyUnam();
      let timestamp = getMexicoTimestamp();

      if (caseRecord.axaCategories === "" || !caseRecord.axaCategories) {
        update(
          {
            caseStatusId: 4,
            informationReason: reason_sendToMedicInformation,
            feaimedica: timestamp,
            caseType: "Seguimiento",
            caseWorking: 0,
            caseLocked: 0,
          },
          caseRecord.id
        ).then((response) => {
          setShouldIgnoreLeaveMessage(true);
          history.push("/mesa_control");
        });
      } else {
        update(
          {
            caseStatusId: 4,
            informationReason: reason_sendToMedicInformation,
            feaimedica: timestamp,
            caseWorking: 0,
            caseLocked: 0,
          },
          caseRecord.id
        ).then((response) => {
          setShouldIgnoreLeaveMessage(true);
          history.push("/mesa_control");
        });
      }
    }
  }

  const onClickSendHospital = async () => {
    await submitFormMedicAssignation();
    if (isEmpty(submitFormMedicAssignationErrors)) {
      let reason_sendToSeguimiento = document.getElementById(
        "reason_reconsideration"
      ).value;
      if (reason_sendToSeguimiento === "") {
        alert("Selecciona una razon para enviar a hospital");
        return;
      }

      if (!validateCommentRequired()) {
        return;
      }
      await saveCommentAutomatically();
      await saveCommentAutomaticallyUnam();
      update(
        { caseStatusId: 7, reasonReconsideration: reason_sendToSeguimiento, caseWorking: 0, caseLocked: 0 },
        caseRecord.id
      ).then((response) => {
        setShouldIgnoreLeaveMessage(true);
        history.push("/mesa_control");
      });
    }
  }

  if (!isCaseInCorrectModule(caseRecord, [CASE_STATUS.CONTROL_DESK, CASE_STATUS.RECONSIDERATION])) {
    return <Redirect to="/error/unauthorized"/>;
  }

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Mesa de Control
      </Alert>

      <Prompt
        message={(location, action) => {
          if (action === "PUSH" && !shouldIgnoreLeaveMessage) {
            if (!window.confirm("Desea salir de la Solicitud en Gestión?")) {
              return false;
            }
            updateCaseWorking(caseRecord.id, 0);
            //updateCaseLocked();
          }

          return true;
        }}
      />

      <CaseHeader caseRecord={caseRecord} showSpecialities={true} />

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
        <Accordion defaultActiveKey="0" className="mt-5">
          <InssuredData
            icon="fa-search"
            eventKey="1"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <HospitalData
            icon="fa-search"
            eventKey="2"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <Documentation data={caseRecord} icon="fa-search" eventKey="4" {...props} />
          <MedicalFees
            icon="fa-search"
            icone="fa-pencil-alt"
            eventKey="5"
            data={caseRecord}
            hideBtnInsurance={false}
            hideFormCreate={true}
            showForm={true}
            ableToHideAuthLetters={true}
            {...props}
          />
          <AuthLetters
            icon="fa-search"
            showForm={false}
            hideDeleteOption={true}
            eventKey="3"
            data={caseRecord}
            disabledAll={false}
            setTotalLetters={() => {}}
            {...props}
          />
          <CaseContext.Provider value={[caseRecord, setCaseRecord]}>
            <UpdateCaseType
              icon="fa-pencil-alt"
              eventKey="6"
              data={caseRecord}
              setBlankUpdateCaseType={true}
              caseTypes={["Alta hospitalaria", "Alta express", "Tabulador", "Seguimiento", "Dictamen", "Reconsideración de Alta", "Revision de corte"]}
            />
          </CaseContext.Provider>
          <SufferingData
            icon="fa-pencil-alt"
            eventKey="7"
            data={caseRecord}
            disabledAll={false}
            bindSubmitForm={() => {}}
          />
          <MedicAssignationTraking
            icon="fa-pencil-alt"
            eventKey="0"
            data={caseRecord}
            mcMovement={mcMovement}
            eventStage="Mesa de Control"
            bindSubmitForm={bindSubmitFormMedicAssignation}
            bindErrors={bindSubmitFormMedicAssignationErrors}
            hasValidationSchema={hasValidationSchema}
          />
        </Accordion>
        <Accordion defaultActiveKey="5" className="mt-5">
          <Binnacle
            icon="fa-pencil-alt"
            eventKey="5"
            data={caseRecord}
            eventStage="Mesa de Control"
            {...props}
          />
        </Accordion>
      </BlockCaseContext.Provider>

      {caseRecord.caseStatusId === 2 ? (
        <Row>
          <Col className="mt-5">
            <Button variant="warning" onClick={onClickSendTracking}>
              Enviar a Seguimiento Hospital
            </Button>

            <Form.Control
              className="mt-5 mr-3"
              as="select"
              name="reason_sendToSeguimiento"
              id="reason_sendToSeguimiento"
              ref={inputReasonTracing}
            >
              <option value="">Selecciona una opcion...</option>
              <option value="Informacion Erronea">Información Errónea</option>
              <option value="Informacion Complementaria">
                Información Complementaria
              </option>
            </Form.Control>
          </Col>

          <Col className="mt-5 mr-5">
            <Button variant="danger" onClick={onClickSendMedicInformation}>
              Enviar a Informacion Médica Hospital
            </Button>

            <Form.Control
              className="mt-5 mr-3"
              as="select"
              name="reason_sendToMedicInformation"
              id="reason_sendToMedicInformation"
              ref={inputReasonMedicInformation}
            >
              <option value="">Selecciona una opcion...</option>
              <option value="Recibido">Recibido</option>
            </Form.Control>
          </Col>

          <Col>
            <Button
              className="mt-5"
              variant="success"
              onClick={onClickSendDictum}
            >
              Enviar a Dictamen
            </Button>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col className="mt-5">
            <Button variant="warning" onClick={onClickSendHospital}>
              Enviar a Hospital
            </Button>

            <Form.Control
              className="mt-5 mr-3"
              as="select"
              name="reason_reconsideration"
              id="reason_reconsideration"
            >
              <option value="">Selecciona una opcion...</option>
              <option value="Rechazo definitivo">Rechazo definitivo</option>
            </Form.Control>
          </Col>

          <Col>
            <Button
              className="mt-5"
              variant="success"
              onClick={onClickSendDictum}
            >
              Enviar a Dictamen
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default WithCommentValidation(ControlDeskDetails);

